import m from "../../../../geodata/es2015/region/usa/msLow";
window.am4geodata_region_usa_msLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/msLow.js
// module id = null
// module chunks = 